export default {
  /// <summary>
  /// PTC Phân bổ Thu ngân sách nhà nước
  /// </summary>
  PTC_RevenueBudget: 5,

  /// <summary>
  /// PTC phân bổ cấp xã Chi thường xuyên
  /// </summary>
  PTC_Ward_ExpenseRegular: 10,

  /// <summary>
  /// PTC phân bổ cấp xã Chi ctmt, mục tiêu khác
  /// </summary>
  PTC_Ward_ExpenseProgram: 13,

  /// <summary>
  /// PTC phân bổ cấp xã Chi khác theo QĐ của pháp luật
  /// </summary>
  PTC_Ward_ExpenseOther: 15,

  /// <summary>
  /// PTC phân bổ cấp xã Chi từ nguồn bổ sung NS cấp trên
  /// </summary>
  PTC_Ward_ExpenseSourceSuperior: 20,

  /// <summary>
  /// PTC phân bổ khối trường Chi thường xuyên
  /// </summary>
  PTC_School_ExpenseRegular: 25,
  /// <summary>
  /// PTC phân bổ khối trường Chi chương trình mục tiêu
  /// </summary>
  PTC_School_ExpenseProgram: 30,

  /// <summary>
  /// PTC phân bổ khối trường Thu hoạt động sự nghiệp, dịch vụ
  /// </summary>
  PTC_School_RevenueBusiness: 35,

  /// <summary>
  /// PTC phân bổ khối trường Chi hoạt động sự nghiệp, dịch vụ
  /// </summary>
  PTC_School_ExpenseBusiness: 40,

  /// <summary>
  /// PTC phân bổ khối phòng ban Chi thường xuyên
  /// </summary>
  PTC_Department_ExpenseRegular: 45,

  /// <summary>
  /// PTC phân bổ khối phòng ban Chi chương trình mục tiêu
  /// </summary>
  PTC_Department_ExpenseProgram: 50,

  /// <summary>
  /// PTC phân bổ khối phòng ban Thu Phí, Lệ phí
  /// </summary>
  PTC_Department_RevenueFees: 55,

  /// <summary>
  /// PTC phân bổ khối phòng ban Chi từ nguồn phí để lại
  /// </summary>
  PTC_Department_ExpenseFees: 60,

  /// <summary>
  /// PTC phân bổ khối phòng ban Thu hoạt động sự nghiệp, dịch vụ
  /// </summary>
  PTC_Department_RevenueBusiness: 65,

  /// <summary>
  /// PTC phân bổ khối phòng ban Chi hoạt động sự nghiệp, dịch vụ
  /// </summary>
  PTC_Department_ExpenseBusiness: 70,

  /// <summary>
  /// PTC phân bổ chi chung huyện Chi thường xuyên
  /// </summary>
  PTC_District_ExpenseRegular: 75,

  /// <summary>
  /// PTC phân bổ chi chung huyện Chi chương trình mục tiêu
  /// </summary>
  PTC_District_ExpenseProgram: 80,

  /// <summary>
  /// PTC phân bổ chi chung huyện Chi khác
  /// </summary>
  PTC_District_ExpenseOther: 85,

  /// <summary>
  /// PTC phân bổ chi chung huyện Chờ phân bổ
  /// </summary>
  PTC_District_WaitAllocation: 90,

  /// <summary>
  /// PTC phân bổ Thu khác theo quy định của pháp luật
  /// </summary>
  PTC_RevenueOther: 95,

  /// <summary>
  /// STC Phân bổ Thu ngân sách nhà nước
  /// </summary>
  STC_RevenueBudget: 100,
  /**
   * STC phân bổ Chi thường xuyên
   */
  STC_Regular: 105,
  /**
   * STC phân bổ Chi đầu tư phát triển
   */
  STC_Invest: 110,
  /**
   * STC phân bổ Chi CTMT, mục tiêu khác
   */
  STC_Project: 115,
  /**
   * STC phân bổ Chi chương trình mục tiêu quốc gia
   */
  STC_QGProject: 120,
  /**
   * STC phân bổ Chi khác theo quy định của pháp luật
   */
  STC_Other: 125,
  /**
   * STC phân bổ Thu khác theo quy định của pháp luật
   */
  STC_RevenueOther: 130,
  /**
   * STC phân bổ Chờ phân bổ
   */
  STC_AllocationPending: 135,
  /**
   * STC phân bổ Thu hoạt động sự nghiệp, dịch vụ
   */
  STC_RevenueBusiness: 140,
  /**
   * STC phân bổ Chi hoạt động sự nghiệp, dịch vụ
   */
  STC_ExpenseBusiness: 145,
  /**
   * STC phân bổ Thu Phí, lệ phí
   */
  STC_RevenueFees: 150,
  /**
   * STC phân bổ Chi từ nguồn phí để lại
   */
  STC_ExpenseFees: 155,

  /**
   * PTC phân bổ cấp xã Chi đầu tư phát triển
   */
  PTC_Ward_ExpenseInvest: 160,
  /**
   * PTC phân bổ khối trường Chi đầu tư phát triển
   */
  PTC_School_ExpenseInvest: 165,
  /**
   * PTC phân bổ Chi đầu tư phát triển chi huyện
   */
  PTC_District_ExpenseInvest: 170,
  /**
   * PTC phân bổ Chi đầu tư phát triển phòng ban
   */
  PTC_Department_ExpenseInvest: 175,
  /**
   * DVCQ phân bổ Chi từ nguồn phí để lại
   */
  DVCQ_Department_ExpenseFees: 176,
  /**
   * DVCQ phân bổ thu phí
   */
  DVCQ_Revenue_Fees: 177,

  /**
   * DVCQ phân bổ thu HĐSN
   */
  DVCQ_Revenue_Business: 178,
  /**
   * DVCQ phân bổ chi HĐSN
   */
  DVCQ_Expense_Business: 179,

  /**
   * Đơn vị chủ quản phân bổ Chi chương trình mục tiêu
   */
  DVQC_Program: 180,

  /**
   * Đơn vị chủ quản phân bổ Chi thường xuyên
   */
  DVQC_Regular: 185,

  /**
   * DVCQ tổng hợp phân bổ Chi nsnn
   */
  DVCQ_Summary_ExpenseBudget: 190,

  /**
   * Sở chủ quản phân bổ chi chương trình mục tiêu
   */
  SCQ_Program: 195,

  /**
   * SCQ phân bổ thu phí
   */
  SCQ_Revenue_Fees: 194,
  /**
  * SCQ phân bổ thu HĐSN
  */
  SCQ_Revenue_Business: 199,

  /**
   * SQC tổng hợp Nguồn hoạt động sử nghiệp dịch vụ
   */
  SCQ_Summary_Business: 200,
  /**
   * SCQ phân bổ chi phí lệ phí
   */
  SCQ_Department_ExpenseFees: 205,
  SCQ_Expense_Business: 208,
  /**
   * SCQ tổng hợp phí, lệ phí
   */
  SCQ_Summary_Fees: 206,

  /**
  * STC phân bổ Chi thường xuyên cấp huyện
  */
  STC_District_Regular: 230,
  /**
   * STC phân bổ Chi đầu tư phát triển cấp huyện
   */
  STC_District_Invest: 240,
  /**
   * STC phân bổ Chi CTMT, mục tiêu khác cấp huyện
   */
  STC_District_Project: 250,
  /**
   * STC phân bổ Chi khác cấp huyện
   */
  STC_District_Other: 260,
  /**
   * Chi bổ sung có mục tiêu cấp huyện
   */
  STC_District_ExpenseBSMT: 270,
  /**
   * Thu khác theo quy định của pháp luật cấp huyện
   */
  STC_District_RevenueOther : 280,
};
